import { createConfirmation } from "react-confirm";
import AddRoomDialog from "./AddRoomDialog";

export const showAddRoomDialog = createConfirmation(AddRoomDialog);
